import PushEnableCard from './PushEnableCard.component'

export default PushEnableCard
